import gql from 'graphql-tag';

export default gql`
  query GetDistinctCompanyBuildingNames {
    buildingFilterOptions {
      name
      floors
    }
  }
`;
